import { ListboxOptions, ListboxButton } from '@headlessui/react'

import { Text } from '~/components/typography'

import Chevron from '~/assets/icons/chevron.svg?react'
import type { Option, Value } from './types'

type SelectListboxShellProps<T extends Value> = {
  selected: Option<T>
  children: React.ReactNode
}

const WRAPPER_CLASS = 'rounded-xl border border-[#8080808C] bg-[#F8F8F8] px-2 py-0.5'
const BUTTON_CLASS = 'group relative w-full rounded px-2 py-0.5 text-left focus:outline-none'
const OPTIONS_CLASS = 'max-h-[30vh] overflow-y-auto'

/**
 * Shared chrome for listbox select: wrapper, trigger button (with selected label + chevron), and options container.
 * Use inside Headless UI <Listbox>; pass options content as children (rendered inside ListboxOptions).
 */
export function SelectListboxShell<T extends Value>({
  selected,
  children,
}: SelectListboxShellProps<T>) {
  return (
    <div className={WRAPPER_CLASS}>
      <ListboxButton className={BUTTON_CLASS}>
        {({ open }) => (
          <>
            {!open && (
              <Text className="text-neutral-midfi-grey" level={3}>
                {selected.label}
              </Text>
            )}
            <Chevron
              className="pointer-events-none absolute right-2 top-1/2 h-3 w-3 -translate-y-1/2 group-data-[open]:rotate-180"
              aria-hidden="true"
            />
          </>
        )}
      </ListboxButton>
      <ListboxOptions className={OPTIONS_CLASS}>{children}</ListboxOptions>
    </div>
  )
}
